module.exports = __webpack_public_path__ + "cd455783/img/ion_calendar-number.3ac5bd07.svg";